import { Typography } from "@stardust-ds/react"
import RcmpModalAdd from "../../molecules/ModalAdd"
import styles from './index.module.scss'
import RcmpLoading from "../../atoms/Loading"
import Modal from "../../molecules/Modal"
import ExportIcon from "../../../assets/icons/ExportIcon"
import Button from "../../atoms/Button"

export default function RcmpModalExport(props) {
  const {
    fnHandleCancel,
    bIsOpen,
    title,
    fnHandleExportToPdf,
    fnHandleExportToXlsx,
    oGetBoardExportRes,
    ...oRest
  } = props



  return (

    <Modal isOpen={bIsOpen} size={"sm"} onRequestClose={fnHandleCancel}>
      <Modal.Header onClose={fnHandleCancel}>
        {title}
      </Modal.Header>
      <Modal.Content>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '28px' }}>
          <ExportIcon width={32} height={32} />
        </div>
        <p style={{ textAlign: 'center' }}>
          Selecione o formato em que deseja exportar!
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '8px', height: '100px' }}>
          <Button onClick={fnHandleExportToXlsx} isLoading={oGetBoardExportRes.loading} style={{ width: '100%', backgroundColor: oGetBoardExportRes.loading ? "" : 'transparent', color: "#6CB6E3", border: "3px solid #6CB6E3", boxShadow: 'none' }} >XLSX</Button>
          {/* <Button onClick={fnHandleExportToPdf} style={{width: '100%', backgroundColor: 'transparent', color: "#6CB6E3", border: "3px solid #6CB6E3", boxShadow: 'none'}} >PDF</Button> */}
        </div>
      </Modal.Content>
    </Modal>
  )
}
